/*
 * Verifica se o ambiente é de produção
 */
export function fn_ambienteIsProducao() {
  const ambiente = import.meta.env.MODE.toUpperCase();
  return ambiente == "PRODUCTION" ? true : false;
}

/*
 * Verifica se o ambiente é de desenvolvimento
 */
export function fn_ambienteIsDesenvolvimento() {
  const ambiente = import.meta.env.MODE.toUpperCase();
  return ambiente == "DEVELOPMENT" ? true : false;
}

/*
 * Retorna a descrição do ambiente
 */
export function fn_getDescricaoAmbiente() {
  const ambiente = import.meta.env.MODE.toUpperCase();

  if (ambiente == "PRODUCTION") {
    return "PRODUÇÃO";
  } else if (ambiente == "DEVELOPMENT") {
    return "DESENVOLVIMENTO";
  } else {
    return ambiente;
  }
}

/*
 * Retorna a base URL da API do backend conforme ambiente, para a conexão com axios
 */
export function fn_getBaseUrlAxios() {
  const isProd = fn_ambienteIsProducao();

  return isProd
    ? import.meta.env.VITE_AXIOS_BASE_URL_PROD
    : import.meta.env.VITE_AXIOS_BASE_URL_DEV;
}

/*
 * Retorna a base URL da API do backend conforme ambiente, para a conexão com axios
 */
export function fn_getBaseUrlFront() {
  const isProd = fn_ambienteIsProducao();

  return isProd
    ? import.meta.env.VITE_FRONT_BASE_URL_PROD
    : import.meta.env.VITE_FRONT_BASE_URL_DEV;
}
